import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { useEffect } from "react";
import { arUniEntryRequestConstantsThunk } from "../../../../../../../store/redux/slice/AppData/arUniEntryRequestConstants";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import ARUniRecognitionStatusSelectField from "../../../../../common/form/fields/ARUniRecognitionStatusSelectField";

const ARUniEntryRequestRecognitionStatusSelectField = ({ labelCode, fieldName, required = false }) => {
  const dispatch = useAppDispatch();

  const arUniEntryRequestConstants = useAppSelector((state) => {
    return state.AppData.arUniEntryRequestConstants;
  });

  useEffect(() => {
    dispatch(arUniEntryRequestConstantsThunk());
  }, [dispatch]);

  return (
    <ARUniRecognitionStatusSelectField
      required={required}
      fieldName={fieldName}
      labelCode={labelCode}
      allowedValues={
        arUniEntryRequestConstants.data && arUniEntryRequestConstants.data.allowedRecognitionStatuses
          ? arUniEntryRequestConstants.data.allowedRecognitionStatuses
          : []
      }
    />
  );
};
export default ARUniEntryRequestRecognitionStatusSelectField;
